import apiClient from '../apiClient';
import { PUT_NOT_ALLOWED_COUNTRY_FOR_COMPANY_URL } from '../apiUrl';

const putAllowedForCompanyApi = (id, data) => {
  return apiClient.put(PUT_NOT_ALLOWED_COUNTRY_FOR_COMPANY_URL(id), data);
};

export default putAllowedForCompanyApi;
